import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    triviaLogo: {
        width: '100%',
        height: 'auto',
    }
}))

export default useStyles